export default {
   /* eslint-disable key-spacing */
   T: 'Tinggi',
   MT: 'Menengah Tinggi',
   MR: 'Menengah Rendah',
   R: 'Rendah',
   /* eslint-enable key-spacing */
}
